import TableCSVExporter from "../../Admin/Users/ConverterCSV";
import React, { Component, Fragment } from "react";
import AUX from "../../../hoc/Aux_";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import axios from "../../Shared/auth-header";
import $ from "jquery";
import { toast } from "react-toastify";
import AuthService from "../../Auth/AuthService";
import Services from "../../Admin/Users/EditUser/EditUserService";

import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

import PermissionFeature from "../../Permissions/PermissionFeature";
import UserFunction from "../../Admin/Users/General/UsersFunction";
import _ from "lodash";
import UsersConstant from "../../Admin/Users/General/UsersConstant";

import SavedSearchCustomizer from "../../AdvanceSearch/SavedSearches/SavedSearchCustomizer";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import CompositionModal from "../../AdvanceSearch/SavedSearches/CompositionModal";
import MemberBucket from "../../AdvanceSearch/SavedSearches/MemberBucket";
import * as Permissions from "../../Permissions/PermissionValues";
import "jspdf-autotable";
import MailGunEmailTypes from "../../Email/Enums/MailGunEmailTypes";
import { CompositionModalMode } from "../../Registrations/Helpers/LookUpValues";
import SeniorityService from "./SeniorityService";
import AreasService from "../../Directory/Areas/AreasService";

const ALL_BUES_TAB_KEY = "allBues";

class Seniority extends Component {
  constructor(props) {
    super(props);
    //console.log(this.props.match.params);
    this.state = {
      page: 1,
      facility: this.props.facility ? this.props.facility : "",
      facilityId: this.props.facilityId ? this.props.facilityId : "",
      data: [],
      sizePerPage: 25,
      totalCount: 0,
      showTotal: true,
      inactiveTotalCount: 0,
      SortOrder: "firstnameasc",
      showActive: true,
      check: "",
      showModal: false,
      showBucketModal: false,
      emails: [],
      displayMembers: [],
      memberId: AuthService.getProfile().memberData.id,
      BCounter: 0,
      valid: false,
      lastPlace: "",
      selectedFields: [],
      columnsToView: [],
      MemberTotalCount: 0,
      customizeColumns: [],
      selectedRows: [],
      local: false,
      memberGridLoad: true,
      disableIcon: "",
      uniqueKey: "membersListing",
      waitingMessage:
        "Processing the file download request. File will automatically download momentarily.",
      activeTabKey: ALL_BUES_TAB_KEY,
      areasCount: 0,
      areasList: [],
      sortField: "natcaBargainingUnitDate", // default sort column
      sortOrder: "asc", // default sort order
    };
    this.setColumnsHeaders = this.setColumnsHeaders.bind(this);
    this.setDefaultColumns = this.setDefaultColumns.bind(this);
    this.RemotePagination = this.RemotePagination.bind(this);
    this.rowMove = this.rowMove.bind(this);
    this.tableDataDisplayer = this.tableDataDisplayer.bind(this);
    this.getAreas = this.getAreas.bind(this);
    this.TieBreakerGroupArrows = this.TieBreakerGroupArrows.bind(this);
    this.html2CanvasSeniority = this.html2CanvasSeniority.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.pdfDiv = this.pdfDiv.bind(this);
    this.handleSortChange = this.handleSortChange.bind(this);
  }
  canViewSavedSearchCustomizer = () => {
    return AuthService.canView(Permissions.Customize_Fields);
  };

  RemotePagination = (
    data,
    page,
    sizePerPage,
    totalSize,
    showTotal,
    rowEvents,
    uniqueKey
  ) => {
    const { columnsToView } = this.state;
    const { sortField, sortOrder } = this.state;

    const customTotal = (from, to, size) => (
      <span
        className="react-bootstrap-table-pagination-total"
        style={{ float: "left", marginTop: "-1px", marginRight: "4px" }}
      >
        {from}
        {" - "}
        {to} of {size} {"   "}
        <b style={{ marginLeft: "4px" }}> Show: </b>
      </span>
    );

    const sizePerPageList = [
      {
        text: "10",
        value: 10,
      },
      {
        text: "25",
        value: 25,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "All",
        value: totalSize,
      },
    ];
    const defaultPaginationConfigs = paginationFactory({
      paginationTotalRenderer: customTotal,
      page: this.state.page,
      sizePerPage,
      totalSize: this.state.totalCount,
      showTotal,
      sizePerPageList,
    });
    return (
      <div>
        <div>
          {/*Table Advnaced Search+Facility Dashboard+ Saved Searches*/}
          <div className="SeniorityMembers">
            {!_.isEmpty(columnsToView) ? (
              <BootstrapTable
                key={uniqueKey}
                keyField="id"
                data={data}
                columns={columnsToView}
                pagination={defaultPaginationConfigs}
                defaultSorted={[{ dataField: sortField, order: sortOrder }]} // ✅ must be array
                rowEvents={rowEvents}
                rowClasses={this.rowClasses}
                remote={{ sort: true }}
                onTableChange={this.handleSortChange}
                id="memberListing"
              />
            ) : (
              "No Visible Columns Found!"
            )}
          </div>
        </div>
      </div>
    );
  };
  handleSortChange = (type, { sortField, sortOrder }) => {
    if (type === "sort") {
      const sortedA = _.orderBy(this.state.data, [sortField], [sortOrder]);
      this.setState({
        sortField,
        sortOrder,
        data: sortedA,
      });
    }
  };
  showSpinner = () => {
    $(".loading").show();
  };

  hideSpinner = () => {
    $(".loading").hide();
  };
  rowClasses = (row, rowIndex) => {
    let { upArrow, downArrow } = this.TieBreakerGroupArrows(row, rowIndex);
    if (upArrow || downArrow) {
      return "bg-light-grey";
    }
  };
  columns = [
    {
      text: "",
      dataField: "",
      hidden: !AuthService.canView(PermissionFeature.FacilityMemberTieBreaker),
      sort: false,
      formatter: (cell, row, rowIndex) => {
        let { upArrow, downArrow } = this.TieBreakerGroupArrows(row, rowIndex);

        return (
          <div className="text-secondary">
            {upArrow &&
            AuthService.canSPView(
              PermissionFeature.tieBreaker,
              row.regionid,
              row.facilityId,
              row.id
            ) ? (
              <i
                className="d-inline fas fa-lg fa-caret-up"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  //  this.rowMove(row, rowIndex, "Up");
                }}
              ></i>
            ) : (
              <i className="d-inline invisible fas fa-lg fa-caret-up"></i>
            )}
            {downArrow &&
            AuthService.canSPView(
              PermissionFeature.tieBreaker,
              row.regionid,
              row.facilityId,
              row.id
            ) ? (
              <i
                class="d-inline fas fa-lg fa-caret-down"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  //    this.rowMove(row, rowIndex, "Down");
                }}
              ></i>
            ) : (
              <i class="d-inline invisible fas fa-lg fa-caret-down"></i>
            )}
          </div>
        );
      },
    },
  ];
  TieBreakerGroupArrows(row, rowIndex) {
    let upArrow = false;
    let downArrow = false;
    if (!_.isEmpty(this.state.data) && this.state.data.length > 0) {
      // for up Arrow
      if (
        rowIndex != 0 &&
        this.state.data[rowIndex].bargainingUnitDate ==
          this.state.data[rowIndex - 1].bargainingUnitDate &&
        this.state.data[rowIndex].natcaBargainingUnitDate ==
          this.state.data[rowIndex - 1].natcaBargainingUnitDate &&
        this.state.data[rowIndex].entryOnDutyDate ==
          this.state.data[rowIndex - 1].entryOnDutyDate &&
        this.state.data[rowIndex].serviceComputationDate ==
          this.state.data[rowIndex - 1].serviceComputationDate &&
        (this.state.data[rowIndex].bargainingUnitDate != null ||
          this.state.data[rowIndex].natcaBargainingUnitDate != null ||
          this.state.data[rowIndex].entryOnDutyDate != null ||
          this.state.data[rowIndex].serviceComputationDate != null)
      ) {
        upArrow = true;
      }
      // for down Arrow
      if (
        this.state.data.length - 1 != rowIndex &&
        this.state.data[rowIndex].bargainingUnitDate ==
          this.state.data[rowIndex + 1].bargainingUnitDate &&
        this.state.data[rowIndex].natcaBargainingUnitDate ==
          this.state.data[rowIndex + 1].natcaBargainingUnitDate &&
        this.state.data[rowIndex].entryOnDutyDate ==
          this.state.data[rowIndex + 1].entryOnDutyDate &&
        this.state.data[rowIndex].serviceComputationDate ==
          this.state.data[rowIndex + 1].serviceComputationDate &&
        (this.state.data[rowIndex].bargainingUnitDate != null ||
          this.state.data[rowIndex].natcaBargainingUnitDate != null ||
          this.state.data[rowIndex].entryOnDutyDate != null ||
          this.state.data[rowIndex].serviceComputationDate != null)
      ) {
        downArrow = true;
      }
    }
    return { upArrow, downArrow };
  }
  orderColumn = {
    text: "",
    dataField: "",
    hidden: !AuthService.canView(PermissionFeature.FacilityMemberTieBreaker),
    sort: false,
    formatter: (cell, row, rowIndex) => {
      let { upArrow, downArrow } = this.TieBreakerGroupArrows(row, rowIndex);

      return (
        <div className="text-secondary">
          {upArrow &&
          AuthService.canSPView(
            PermissionFeature.FacilitySeniorityTieBreaker,
            row.regionid,
            row.facilityId,
            row.id
          ) ? (
            <i
              className="d-inline fas fa-lg fa-caret-up"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                this.rowMove(row, rowIndex, "Up");
              }}
            ></i>
          ) : (
            <i className="d-inline invisible fas fa-lg fa-caret-up"></i>
          )}
          {downArrow &&
          AuthService.canSPView(
            PermissionFeature.FacilitySeniorityTieBreaker,
            row.regionid,
            row.facilityId,
            row.id
          ) ? (
            <i
              class="d-inline fas fa-lg fa-caret-down"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                this.rowMove(row, rowIndex, "Down");
              }}
            ></i>
          ) : (
            <i class="d-inline invisible fas fa-lg fa-caret-down"></i>
          )}
        </div>
      );
    },
  };
  rowMove = async (row, rowIndex, action) => {
    let tempRow = _.cloneDeep(row);
    let { data } = this.state;
    if (action == "Up" && rowIndex > 0 && data.length > 0) {
      await Services.TiebreakerUpdate(
        row.id,
        row.tieBreaker,
        data[rowIndex - 1].id,
        data[rowIndex - 1].tieBreaker
      );
      if (data[rowIndex - 1].tieBreaker == row.tieBreaker) {
        toast.warn(
          "Both the Tiebreakers' values are equal. After re-sorting, the members' positions will remain the same."
        );
      }
      row.tieBreaker = data[rowIndex - 1].tieBreaker;
      data[rowIndex - 1].tieBreaker = tempRow.tieBreaker;
      data[rowIndex] = data[rowIndex - 1];
      data[rowIndex - 1] = row;
    } else if (
      action == "Down" &&
      rowIndex < data.length - 1 &&
      data.length > 0
    ) {
      await Services.TiebreakerUpdate(
        row.id,
        row.tieBreaker,
        data[rowIndex + 1].id,
        data[rowIndex + 1].tieBreaker
      );
      if (data[rowIndex + 1].tieBreaker == row.tieBreaker) {
        toast.warn(
          "Both the Tiebreakers' values are equal. After re-sorting, the members' positions will remain the same."
        );
      }
      row.tieBreaker = data[rowIndex + 1].tieBreaker;
      data[rowIndex + 1].tieBreaker = tempRow.tieBreaker;
      data[rowIndex] = data[rowIndex + 1];
      data[rowIndex + 1] = row;
    }
    this.setState({ data: data });
  };
  setColumnsHeaders = async (colHeaders) => {
    if (colHeaders) {
      await this.setState({
        selectedFields: colHeaders,
      });
      let searchCols = UserFunction.CreateCostomColumnHeader(colHeaders);
      this.columns = [this.orderColumn, ...searchCols];
      await this.setState({
        columnsToView: this.columns,
      });
    }
  };

  doPreventDefault = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };
  async getMembers(facility, activeTabKeyOverride) {
    const activeTabKey =
        activeTabKeyOverride !== undefined && activeTabKeyOverride !== null
            ? activeTabKeyOverride
            : this.state.activeTabKey;
    const isAllBuesTabSelected = activeTabKey === ALL_BUES_TAB_KEY;
    const parsedAreaId = parseInt(activeTabKey, 10);
    const formData = {
      Keyword: "",
      Facility: facility,
      Region: null,
      PageNo: this.state.page,
      PageSize: this.state.sizePerPage,
      ShowOnlyActive: true,
      IsSeniorityCall: true,
      ShowBoth: false,
    };

      if (this.state.areasCount === 0 || isAllBuesTabSelected) {
          formData.AreaId = -1;
      } else if (this.state.areasCount > 0 && !isAllBuesTabSelected) {
          formData.AreaId = !isNaN(parsedAreaId) ? parsedAreaId : null;
      }

    await this.setState({ memberGridLoad: true, ApiCriteria: formData });

    let data = await SeniorityService.GetMembers(formData);
    if (data != null) {
      await this.setState({
        data: _.isEmpty(data.data) ? [] : data.data,
        totalCount: data.totalCount,
        memberGridLoad: false,
      });
    } else {
      await this.setState({ memberGridLoad: false });
    }
  }

  componentDidMount() {
    if (this.props.location && this.props.location.lastPlace) {
      this.setState({ lastPlace: this.props.location.lastPlace });
    }
    this.setState({
      facility: this.props.facility,
      facilityId: this.props.facilityId,
    });
    this.getAreas();

    this.setDefaultColumns();
  }

  async getAreas() {
    if (this.state.facility) {
      let result = await AreasService.GetAreasByFacilityCode(
        this.state.facility
      );
      if (result != null) {
        if (result.totalCount > 0) {
            const nextTabKey =
                this.state.activeTabKey === "" ||
                    this.state.activeTabKey === undefined ||
                    this.state.activeTabKey === null
                    ? ALL_BUES_TAB_KEY
                    : this.state.activeTabKey;
          await this.setState({
            activeTabKey: nextTabKey,
            areasCount: result.totalCount,
            areasList: result.data,
          });

            await this.getMembers(this.props.facility, nextTabKey);
        }
      }
    }
  }

  filterMembers = (Name) => {
    console.log(this.state.displayMembers);
    if (Name != "") {
      this.setState((prevState) => ({
        displayMembers: prevState.displayMembers.filter(
          (el) => el.firstName.includes(Name) || el.lastName.includes(Name)
        ),
      }));
    } else {
      this.setState({
        displayMembers: this.state.displayMembers,
      });
    }
  };

  onCSVClick = async () => {
    this.setState({
      disableIcon: "disableDownloadIcons",
    });
    toast.success(this.state.waitingMessage);

    this.showSpinner();
    let data = this.state.data;
    if (data != null) {
      const dataTable = document.getElementById("pdfdiv");
      const exporter = new TableCSVExporter(dataTable);
      const csvOutput = exporter.convertToCSV();
      const csvBlob = new Blob([csvOutput], {
        type: "text/csv",
      });
      const blobUrl = URL.createObjectURL(csvBlob);
      const anchorElement = document.createElement("a");

      anchorElement.href = blobUrl;
      anchorElement.download =
        "Seniority-Export-" + this.props.facility + ".csv";
      anchorElement.click();
    }

    this.hideSpinner();
    this.setState({
      disableIcon: "",
    });
  };
  html2CanvasSeniority = async () => {
    $("#pdfdiv")
      .find(".react-bootstrap-table-pagination")
      .css("display", "none");

    const input = document.getElementById("pdfdiv");
    var w = document.getElementById("pdfdiv").offsetWidth;
    var h = document.getElementById("pdfdiv").offsetHeight;
    $("#pdfdiv").css("position", "absolute");
    $("#pdfdiv").css("z-index", "-100");

    $("#pdfdiv").css("display", "");
    let canvas = await html2canvas(input);
    this.showSpinner();

    const pageWidth = 210;
    const pageHeight = 295;
    const marginTop = 19.05; // ¾ inch
    const marginBottom = 19.05;
    const marginLeft = 25.4;
    const marginRight = 25.4;

    const usableWidth = pageWidth - marginLeft - marginRight;
    const usableHeight = pageHeight - marginTop - marginBottom;

    const imgWidth = usableWidth;
    const imgHeightTotal = (canvas.height * imgWidth) / canvas.width;

    const onePageCanvasHeight = Math.floor(
      (usableHeight * canvas.width) / imgWidth
    );
    const totalPages = Math.ceil(canvas.height / onePageCanvasHeight);

    const doc = new jsPDF("p", "mm");

    for (let i = 0; i < totalPages; i++) {
      if (i > 0) doc.addPage();

      const pageCanvas = document.createElement("canvas");
      pageCanvas.width = canvas.width;
      pageCanvas.height = onePageCanvasHeight;

      const pageContext = pageCanvas.getContext("2d");
      pageContext.fillStyle = "white";
      pageContext.fillRect(0, 0, pageCanvas.width, pageCanvas.height);

      pageContext.drawImage(
        canvas,
        0,
        i * onePageCanvasHeight,
        canvas.width,
        onePageCanvasHeight,
        0,
        0,
        canvas.width,
        onePageCanvasHeight
      );

      const pageImgData = pageCanvas.toDataURL("image/png");

      const pageImgHeight = (pageCanvas.height * imgWidth) / pageCanvas.width;

      doc.addImage(
        pageImgData,
        "PNG",
        marginLeft,
        marginTop,
        imgWidth,
        pageImgHeight
      );
    }

    $("#pdfdiv").css("display", "none");
    doc.save("Seniority-Export-" + this.props.facility + ".pdf");
    this.hideSpinner();
    await this.setState({ disableIcon: "" });
  };
  hideModal = () => {
    this.setState({ showModal: false });
  };
  onPDFClick = async () => {
    this.showSpinner();
    this.setState({
      disableIcon: "disableDownloadIcons",
    });
    toast.success(this.state.waitingMessage);

    let data = this.state.data;
    if (data != null) {
      await this.html2CanvasSeniority();
      this.hideSpinner();
    }
  };

  setDefaultColumns = async () => {
    const { columnsToView } = this.state;
    if (columnsToView && columnsToView.length > 0) {
      return;
    }

    let url = "api/SavedSearch/GetDefaultColumns?isSeniority=true";
    let { data: defaultColumns } = await axios.get(url);
    var items = JSON.parse(
      localStorage.getItem("SMembers_" + this.state.memberId)
    );
    if (items !== null) {
      var filteredItems = items.filter(
        (x) => !defaultColumns.some((d) => d.id === x.id)
      );
      Array.prototype.push.apply(defaultColumns, filteredItems);
    }

    await this.setState({ customizeColumns: defaultColumns });
    await this.setColumnsHeaders(defaultColumns);

    await this.getMembers(this.props.facility);
  };
  isAreaActive = (list, id) => {
    return (
      Array.isArray(list) &&
      list.length > 0 &&
      id !== 0 &&
      list[0] &&
      list[0].id !== id
    );
  };
  setActiveTab = (k) => {
    const numericId = parseInt(k, 10);
    this.setState(
        {
            activeTabKey: k,
            isAreaTab:
                !isNaN(numericId) && this.isAreaActive(this.state.areasList, numericId),
        },
        () => this.getMembers(this.props.facility, k)
    );
  };
  pdfDiv() {
    let { data, sortField, sortOrder } = this.state;
    if (!_.isEmpty(this.state.data)) {
      return (
        <div id="pdfdiv" style={{ display: "none" }}>
          <BootstrapTable
            keyField="id"
            data={data}
            sort={{ dataField: sortField, order: sortOrder }}
            columns={(() => {
              let c = _.cloneDeep(this.columns);
              if (c[0].dataField == "" && this.props.facility) {
                c.splice(0, 1);
                console.log("columns2", this.columns);

                return c;
              }
              return this.columns;
            })()}
            false
            false
            false
            id="membersListingPdf"
          />
        </div>
      );
    }
  }
  tableDataDisplayer() {
    let {
      totalCount,
      data,
      page,
      uniqueKey,
      sizePerPage,
      showTotal,
    } = this.state;

    if (this.state.memberGridLoad === true) {
      return (
        <div className="text-center pb-4 pt-2 mt-4">
          <div role="status" class="spinner-border">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      );
    } else if (_.isEmpty(this.state.data)) {
      return (
        <>
          {this.state.memberGridLoad === false && (
            <div class="container h-100">
              <div class="row spinnerFacilityCategory">
                <h5>No Members Found!</h5>
              </div>
            </div>
          )}
        </>
      );
    } else {
      return (
        <Fragment>
          {this.RemotePagination(
            data,
            page,
            sizePerPage,
            totalCount,
            showTotal,
            this.rowEvents,

            uniqueKey
          )}
        </Fragment>
      );
    }
  }
  render() {
    let { selectedFields, data } = this.state;

    return (
      <AUX>
        <div className="container-fluid">
          <div
            className={`row mx-0 w-100 align-items-center my-3`}
            // style={{ marginBottom: 1 + "em" }}
          >
            {/* Member Listing Accordion Toolbar Starts */}
            <div className="col-sm-6 offset-sm-6 pr-sm-0 text-right inline-toolbar-item">
              {AuthService.canView(Permissions.Export_Results) &&
                this.state.data != null &&
                this.state.data.length > 0 && (
                  <span className={this.state.disableIcon}>
                    <i
                      class="fas fa-file-pdf"
                      onClick={() => this.onPDFClick()}
                    ></i>

                    <i
                      class="fas fa-file-csv"
                      onClick={() => this.onCSVClick()}
                    ></i>
                  </span>
                )}

              {this.canViewSavedSearchCustomizer() === true &&
                this.state.data.length > 0 && (
                  <SavedSearchCustomizer
                    FacilityDashboard={true}
                    Facility={this.state.facility}
                    forceSearchRefresh={(forceRefresh, selectedFields) => {
                      if (
                        !this.state.savedSearchId ||
                        this.state.savedSearchId <= 0
                      ) {
                        this.setColumnsHeaders(selectedFields);

                        return;
                      }
                    }}
                    selectedFields={selectedFields}
                    PACMembers={false}
                    FacilityMembers={true}
                  ></SavedSearchCustomizer>
                )}
            </div>
          </div>
          <div className="row">
            <div className="col-12" style={{ minHeight: "fit-content" }}>
              {this.state.areasCount > 0 ? (
                <>
                  <Tabs
                    defaultActiveKey={ALL_BUES_TAB_KEY}
                    id="uncontrolled-tab-example"
                    className=""
                    activeKey={this.state.activeTabKey}
                    onSelect={(k) => this.setActiveTab(k)}
                  >
                    <Tab eventKey={ALL_BUES_TAB_KEY} title={<span className = "font-weight-bold">All BUEs</span>}>
                        {this.tableDataDisplayer()}
                    </Tab>
                    {this.state.areasList.map((item, index) => (
                      <Tab
                        eventKey={item.id}
                        title={
                          <>
                            <span className="font-weight-bold">
                              {" "}
                              {item.code}{" "}
                            </span>
                          </>
                        }
                      >
                        {this.tableDataDisplayer()}
                      </Tab>
                    ))}
                  </Tabs>
                  {this.pdfDiv()}
                </>
              ) : (
                <>
                  {this.tableDataDisplayer()}
                  {this.pdfDiv()}
                </>
              )}
            </div>
          </div>
        </div>
      </AUX>
    );
  }
}

// export default Users;
export default Seniority;
